import { Row, Col, Menu, Dropdown } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { edicionConvocatoria, idConvocatorias } from "../../../redux/actions/convocatoriaAction";

import { DownOutlined } from "@ant-design/icons";

interface IProps {
  idconvocatorias: number;
  activo: string;
  editar?: boolean;
}

export const Navegador: React.FC<IProps> = (props: IProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const menu = () => {
    return (
      <Menu>
        <Menu.Item key="1" onClick={() => abrirEditar("infoconvocatoria")}>
          Información general
        </Menu.Item>
        <Menu.Item key="2" onClick={() => abrirEditar("cronograma")}>
          Cronograma
        </Menu.Item>
        <Menu.Item key="3" onClick={() => abrirEditar("documentos")}>
          Doc. administrativos
        </Menu.Item>
        <Menu.Item key="4" onClick={() => abrirEditar("documentacionTecnica")}>
          Doc. técnicos
        </Menu.Item>
        <Menu.Item key="5" onClick={() => abrirEditar("documentacionConvocatoria")}>
          Doc. general
        </Menu.Item>
      </Menu>
    );
  };
  const abrirEditar = (route: string) => {
    dispatch(edicionConvocatoria(true));
    dispatch(idConvocatorias(props.idconvocatorias));
    return navigate(`/Administrador/${route}`);
  };
  return (
    <div>
      <Row
        className="width-100"
        style={{ backgroundColor: "rgba(109, 163, 252, 0.25)", paddingRight: "1%", alignItems: "center" }}
      >
        <Col span={24} className="justify-content-flex-end" style={{ alignItems: "center" }}>
          <span className="font-family-Montserrat-SemiBold font-size-12px">Crear convocatoria: </span>
          <span style={{ marginLeft: '5px'}} className="font-family-Montserrat-Regular font-size-12px">{` ${props.activo}`}</span>
          <Dropdown.Button  overlay={() => menu()} className="button-ant-ant" icon={<DownOutlined />} />
        </Col>
      </Row>
    </div>
  );
};
